import styled from 'styled-components';

// ----------------------------------------------------------------------

export const Label = styled.p`
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;

  > span {
    color: ${({theme}) => theme.colors.primary[400]};
  }
`;

export const Description = styled.p`
  font-size: 12px;
  color: ${({theme}) => theme.colors.grayscale[400]};
  line-height: 20px;
`;

export const RequisiteWrapper = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`;

export const Requisite = styled.div<{ $check?: boolean }>`
  font-size: 12px;
  display: flex;
  align-items: center;
  color: ${(props) => props.$check ? props.theme.colors.info : props.theme.colors.grayscale[400]};

  svg {
    margin-right: 4px;
    stroke: ${(props) => props.$check ? props.theme.colors.info : props.theme.colors.grayscale[400]};
  }
`;

export const Message = styled.p<{ type?: string }>`
  font-size: 12px;
  color: ${(props) => props.type ? props.theme.colors[props.type] : props.theme.colors.error};
  display: flex;
  align-items: center;

  &:before {
    content: '';
    width: 16px;
    height: 16px;
    background-image: url(/assets/form/${(props) => props.type ? props.type : 'error'}.png);
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 2px;
  }
`;

export const TextFields = styled.input<{ $error?: boolean }>`
    width: 100%;
    padding: 0 20px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.$error ? props.theme.colors.error : props.theme.colors.grayscale[200]};
    margin-bottom: 4px;
`;

export const SelectFields = styled.select<{ $error: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;

  select {
    width: 100%;
    border: 1px solid ${(props) => props.$error ? props.theme.colors.error : props.theme.colors.grayscale[200]};
  }
`;

export const PasswordFields = styled.div<{ $error: boolean, $icon: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.$error ? props.theme.colors.error : props.theme.colors.grayscale[200]};
  overflow: hidden;
  margin-bottom: 4px;

  > input {
    width: calc(100% - 24px);
    padding: 0 10px 0 20px;
    border: none;
  }

  > button {
    width: 24px;
    height: 24px;
    background-image: url(/assets/form/${(props) => props.$icon}.svg);
    background-size: 22px auto;
    background-position: center center;
    background-repeat: no-repeat;
    border: none;
  }
`;

export const ButtonFields = styled.div<{ $error?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;

  input {
    width: calc(100% - 90px);
    padding: 0 20px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.$error ? props.theme.colors.error : props.theme.colors.grayscale[200]};
  }

  button {
    padding: 0;
    width: 80px;
  }
`;

export const MultipleFields = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  > div:first-child {
    width: 130px;
  }

  > div:last-child {
    display: flex;
    width: calc(100% - 140px);

    > div {
      width: calc((100% - 15px) / 2);
    }

    > p {
      width: 15px;
      height: 40px;
      line-height: 40px;
      color: #6B7A99;
      font-size: 16px;
      text-align: center;
      margin-bottom: 4px;
    }
  }
`;

export const CodeFields = styled.div<{ $error?: boolean, $disabled?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.$error ? props.theme.colors.error : props.theme.colors.grayscale[200]};
  overflow: hidden;
  background-color: ${(props) => props.$disabled ? props.theme.colors.grayscale[50] : '#FFFFFF'};

  input {
    width: calc(100% - 60px);
    padding: 0 20px;
    border: none;
  }
    
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox  */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  p {
    padding-right: 10px;
    width: 60px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    color: ${({theme}) => theme.colors.error};
  }
`;